import tokens from './tokens'
import { PoolConfig } from './types'

const pools: PoolConfig[] = [
  {
    sousId: 0,
    stakingToken: tokens.dmd,
    isFinished: false,
  },
  {
    sousId: 14,
    stakingToken: tokens.wftm,
    isFinished: false,
    fee: 2,
  },
  {
    sousId: 15,
    stakingToken: tokens.usdc,
    isFinished: true,
    fee: 2,
  },
  {
    sousId: 16,
    stakingToken: tokens.dai,
    isFinished: true,
    fee: 2,
  },
  {
    sousId: 17,
    stakingToken: tokens.usdt,
    isFinished: true,
    fee: 2,
  },
  {
    sousId: 18,
    stakingToken: tokens.btc,
    isFinished: true,
    fee: 2,
  },
  {
    sousId: 19,
    stakingToken: tokens.eth,
    isFinished: true,
    fee: 2,
  },
  {
    sousId: 20,
    stakingToken: tokens.bnb,
    isFinished: true,
    fee: 2,
  },
  {
    sousId: 23,
    stakingToken: tokens.mim,
    isFinished: true,
    fee: 2,
  },
  {
    sousId: 24,
    stakingToken: tokens.boo,
    isFinished: true,
    fee: 2,
  },
  {
    sousId: 37,
    stakingToken: tokens.reaper,
    isFinished: true,
  },
  {
    sousId: 44,
    stakingToken: tokens.r4id,
    isFinished: false,
  },
]

export default pools
